module.exports = __webpack_public_path__ + "img/commun_two.08c52e85.png";